import React from "react";
import {
    Modal,
    message,
    Upload,
    Form,
    Icon,
    InputNumber,
    Input,
    Select,
    Popconfirm,
    Button,
} from "antd";
import _ from "lodash";
import Services from "../../../services/categories";
import ItemFormHelper from "../itemForm/ItemFormHelper";

//   upload-script end
let PreviewFromLink = {
    _id: "",
    uid: "",
    name: "",
    status: "done",
    response: "ok",
    url: "",
};

class TeaserForm extends React.Component {
    // form-scripts start
    handleFormLayoutChange = (e) => {
        this.setState({ formLayout: e.target.value });
    };

    constructor() {
        super();
        this.state = {
            formLayout: "horizontal",
            previewVisible: false,
            addOption: false,
            visible: false,
            addItem: false,
            previewImage: "",
            teaser: { title: [], fields: [], _id: [] },

            sortNo: "",
            heading: "",
            subHeading: "",
            bulletTextOne: "",
            bulletTextTwo: "",
            bulletTextThree: "",
            bulletTextFour: "",

            fileList: [],
            imageFiles: [],

            files: [],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { editFormContents } = this.props;

        if (!_.isEqual(prevProps.editFormContents, editFormContents)) {

            if (editFormContents?.length) {
                const title = [], fields = [], fileList = [], _id = [];
                const formattedTeaserData = editFormContents[0].teaser?.map((item) => {
                    _id.push(item?._id);
                    title.push(item?.title);
                    fields.push("");
                    fileList.push([
                        {
                            ...PreviewFromLink,
                            // _id: item?._id,
                            uid: item?.fileName,
                            name: item?.originalName,
                            url: `/api/util/image?key=${item?.fileName}`,
                        },
                    ]);
                });

                this.setState({
                    teaser: { title, fields, _id },
                    fileList,
                    sortNo: editFormContents[0].sort,
                    heading: editFormContents[0].heading,
                    subHeading: editFormContents[0].subHeading,
                    bulletTextOne: editFormContents[0].bulletTextOne,
                    bulletTextTwo: editFormContents[0].bulletTextTwo,
                    bulletTextThree: editFormContents[0].bulletTextThree,
                    bulletTextFour: editFormContents[0].bulletTextFour
                });
            }
        }
    }

    showModal = () => {
        this.setState({
            visible: true
        });
    }

    handleOk = (e) => {
        this.setState({
            visible: false
        });
    }

    addItem = (e) => {
        this.setState({
            addItem: !this.state.addItem
        });
    }

    addOption = (e) => {
        this.setState({
            addOption: !this.state.addOption
        });
    }

    handleCancel = (e) => {
        this.setState({
            visible: false
        });
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }

    handleRemove = (file, i) => {
        this.setState((prev) => {
            if (
                JSON.stringify(prev.imageFiles[i]?.uid) === JSON.stringify(file?.uid)
            ) {
                prev.imageFiles[i] = null;
            }
            delete prev.fileList[i];
            return { ...prev };
        });
    }

    handleUploadBegin = (file, i) => {
        this.setState((prev) => {
            prev.imageFiles[i] = file;
            return {
                imageFiles: prev.imageFiles,
            };
        });
    }

    handleChange = (e, index) => {
        this.setState((prev) => {
            prev.fileList[index] = e.fileList;
            return { fileList: prev.fileList };
        });
    }

    customRequest = ({ file, onSuccess }) => {
        if (file.status !== "uploading") {
        }
        if (file.status === "done") {
            message.success(`${file.name} file uploaded successfully`);
        } else if (file.status === "error") {
            message.error(`${file.name} file upload failed.`);
        }
        setTimeout(() => onSuccess("ok"), 0);
    }

    addSortNo = (value) => {
        this.setState({ sortNo: value })
    }

    addHeading = (value) => {
        this.setState({ heading: value.target.value })
    }

    addSubHeading = (value) => {
        this.setState({ subHeading: value.target.value })
    }

    addBulletTextOne = (value) => {
        this.setState({ bulletTextOne: value.target.value })
    }

    addBulletTextTwo = (value) => {
        this.setState({ bulletTextTwo: value.target.value })
    }

    addBulletTextThree = (value) => {
        this.setState({ bulletTextThree: value.target.value })
    }

    addBulletTextFour = (value) => {
        this.setState({ bulletTextFour: value.target.value })
    }

    columnGenerator = (id) => {
        return (
            <React.Fragment>
                <div className="ant-row" key={id}>
                    <div className="ant-col-md-12">
                        <Input type="text" placeholder="Add Title" />
                    </div>

                    <div className="ant-col-md-12">
                        <Input type="text" placeholder="Add Url" />
                    </div>
                </div>
                <br />
            </React.Fragment>
        );
    };

    _renderTeaser = (i) => {
        const addTitle = (e) => {
            e.persist();
            this.setState((prev) => {
                prev.teaser.title[i] = e.target.value;
                return {
                    teaser: prev.teaser,
                };
            });
        };

        const { previewVisible, previewImage, fileList, files } = this.state;
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text"><span style={{ color: "red" }}>*</span>Upload</div>
            </div>
        );
        return (
            <div className="ant-row" key={"Teaser_" + i}>
                <div className="ant-col-md-8">
                    <Input
                        required
                        type="text"
                        placeholder="Add Title"
                        onChange={addTitle.bind(this)}
                        value={this.state.teaser.title[i]}
                    />
                </div>

                <div className="ant-col-md-4 upload-img-main">Thumbnail:
                    <Upload
                        listType="picture-card"
                        fileList={fileList[i]}
                        onPreview={this.handlePreview}
                        customRequest={this.customRequest}
                        beforeUpload={(file) => this.handleUploadBegin(file, i)}
                        onChange={(e) => this.handleChange(e, i)}
                        onRemove={(file) => this.handleRemove(file, i)}
                        accept="image/jpeg, image/png"
                    >
                        {fileList[i]?.length ? null : uploadButton}
                    </Upload>
                    <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.handleCancel}
                    >
                        <img alt="example" style={{ width: "100%" }} src={previewImage} />
                    </Modal>
                </div>

                <div className="ant-col-md-4 rite-btn">
                    <div className="action-btn">
                        <a href="" title="Delete">
                            <Popconfirm
                                title="Are you sure delete this ?"
                                onConfirm={() => {
                                    this.setState((prev) => {
                                        Services.removeBanner(this.state.teaser._id[i])
                                        delete prev.teaser?.fields[i];
                                        delete prev.fileList[i];
                                        return { teaser: prev.teaser, fileList: prev.fileList };
                                    });
                                }}
                                onCancel={() => { }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <span className="gx-link" title="Delete">
                                    <i class="icon icon-trash"></i>
                                </span>
                            </Popconfirm>
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        // TeaserState Setter Start
        ItemFormHelper.setTeaserState({
            teaser: this.state.teaser,
            images: this.state.imageFiles,
            sortNo: this.state.sortNo,
            heading: this.state.heading,
            subHeading: this.state.subHeading,
            bulletTextOne: this.state.bulletTextOne,
            bulletTextTwo: this.state.bulletTextTwo,
            bulletTextThree: this.state.bulletTextThree,
            bulletTextFour: this.state.bulletTextFour
        });
        // TeaserState Setter End

        return (
            <Form>
                <div className="ant-row hd-title gx-m-0">
                    <div className="ant-col-md-12">
                        <h1>Manage Teaser</h1>
                    </div>
                    <div className="ant-col-md-12 rite-btn">
                        <Button
                            type="primary"
                            className="color-white"
                            onClick={() => {
                                this.setState((prev) => {
                                    prev.teaser.fields.push("");
                                    return { teaser: prev.teaser };
                                });
                            }}
                        >
                            <i class="icon icon-add"></i> Add
                        </Button>
                    </div>
                </div>

                <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">

                        <div className="item-detail-edit-box">
                            <InputNumber
                                required
                                placeholder="Sort No"
                                onChange={this.addSortNo}
                                value={this.state.sortNo}
                            />
                        </div>
                        <div className="item-detail-edit-box">
                            <Input
                                required
                                type="text"
                                placeholder="Heading"
                                onChange={this.addHeading}
                                value={this.state.heading}
                            />
                        </div>

                        <div className="item-detail-edit-box">
                            <Input
                                required
                                type="text"
                                placeholder="Sub Heading"
                                onChange={this.addSubHeading}
                                value={this.state.subHeading}
                            />
                        </div>

                        <div className="item-detail-edit-box">
                            <Input
                                required
                                type="text"
                                placeholder="Text 1"
                                onChange={this.addBulletTextOne}
                                value={this.state.bulletTextOne}
                            />
                        </div>

                        <div className="item-detail-edit-box">
                            <Input
                                required
                                type="text"
                                placeholder="Text 2"
                                onChange={this.addBulletTextTwo}
                                value={this.state.bulletTextTwo}
                            />
                        </div>

                        <div className="item-detail-edit-box">
                            <Input
                                required
                                type="text"
                                placeholder="Text 3"
                                onChange={this.addBulletTextThree}
                                value={this.state.bulletTextThree}
                            />
                        </div>

                        <div className="item-detail-edit-box">
                            <Input
                                required
                                type="text"
                                placeholder="Text 4"
                                onChange={this.addBulletTextFour}
                                value={this.state.bulletTextFour}
                            />
                        </div>

                        <br />
                        <div>
                            {this.state.teaser?.fields?.map((item, index) => {
                                return this._renderTeaser(index);
                            })}
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

export default TeaserForm;